import { useShallow } from "zustand/react/shallow";

import {
  SortAlphabetAscendingIcon,
  SortAlphabetDescendingIcon,
  SortDescendingIcon,
} from "ui/Icons/Icons";

import { useRestockingServiceStore } from "../stores/restockingServiceStore";

export function RestockingSortIcon({ boxSize }: { boxSize: string }) {
  const { sortOrder, sortBy } = useRestockingServiceStore(
    useShallow((state) => ({
      sortOrder: state.sortOrder,
      sortBy: state.sortBy,
    })),
  );
  if (sortBy === "priority") {
    return <SortDescendingIcon boxSize={boxSize} />;
  } else {
    return sortOrder === "asc" ? (
      <SortAlphabetAscendingIcon boxSize={boxSize} />
    ) : (
      <SortAlphabetDescendingIcon boxSize={boxSize} />
    );
  }
}
